module.exports = __webpack_public_path__ + "img/Group 427320375.d1c94b8f.svg";